



















import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  name: 'CookieBar',
})
export default class CookieBar extends Vue {
  isVisible = false;

  mounted() {
    if (!localStorage.getItem('cookie-bar-closed')) {
      this.isVisible = true;
    }
  }

  onClose() {
    this.isVisible = false;
    localStorage.setItem('cookie-bar-closed', '1');
  }
}
